export const COLUMNS: string[] = [
	'pages.VR.name', 'pages.VR.description', '',
];

export const SELECTORS: string[] = [
	'name', 'description',
];
